<template>
  <div class="flex flex-col gap-5">
    <div class="logistic-container h-full">
      <div class="pb-3 w-full flex flex-row items-center justify-between border-b-2 border-dashed">
        <span class="text-lg font-semibold">
          PTD - {{ moment().month((filterMonth || currentSelectedMonth) - 1).format('MMM') }}
        </span>
        <date-picker
          v-model="filterMonth"
          format="MMMM"
          type="month"
          value-type="M"
          placeholder="Month"
          class="px-2"
          hide-year-label
        />
      </div>
      <div class="w-full">
        <logistic-cost-per-activity-card
          class="h-full"
          :summary-data="ptdSummaryData"
          :activity-data="ptdTableData"
        />
      </div>
    </div>
    <div class="logistic-container">
      <div class="pb-3 w-full flex flex-row items-center justify-between border-b-2 border-dashed">
        <span class="text-lg font-semibold">
          Full Year
        </span>
      </div>
      <logistic-cost-per-activity-card
        :summary-data="annualSummaryData"
        :activity-data="annualTableData"
        type="fullYear"
      />
    </div>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex';

import DatePicker from '@/components/datePicker'
import LogisticCostPerActivityCard
  from "@/views/performanceCostAnalysis/costAnalysis/components/LogisticCostPerActivityCard.vue";

export default {
  name: 'LogisticCostPerActivity',
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    DatePicker,
    LogisticCostPerActivityCard
  },
  data() {
    const currentMonth = this.moment().format('M')
    return {
      currentSelectedMonth: currentMonth,
      filterMonth: currentMonth,
      ptdSummaryData: null,
      ptdTableData: null,
      annualSummaryData: null,
      annualTableData: null
    }
  },
  mounted() {
    this.fetchLogisticCostPerActivity()
  },
  computed: {
    ...mapGetters({
      logisticCostPerActivity: 'CostAnalysis/logisticCostPerActivity'
    })
  },
  watch: {
    filters: {
      deep: true,
      handler (val) {
        if (val?.month) {
          this.currentSelectedMonth = val.month
          this.filterMonth = val.month
        }
        this.fetchLogisticCostPerActivity()
      }
    },
    filterMonth: {
      handler (val) {
        this.fetchLogisticCostPerActivity()
      }
    },
    logisticCostPerActivity: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && val.logistic_cost_per_activity_ptd) {
          this.ptdSummaryData = val.logistic_cost_per_activity_ptd.summary
          this.ptdTableData = val.logistic_cost_per_activity_ptd.details
          this.annualSummaryData = val.logistic_cost_per_activity_full_year.summary
          this.annualTableData = val.logistic_cost_per_activity_full_year.details
        } else {
          this.ptdSummaryData = null
          this.ptdTableData = null
        }
      }
    }
  },
  methods: {
    async fetchLogisticCostPerActivity() {
      const filters = {
        ...this.filters,
        month: this.filterMonth || this.filters.month
      }
      try {
        await this.$store.dispatch('CostAnalysis/fetchLogisticCostPerActivity', filters);
      } catch (err) {
        throw err;
      }
    }
  }
};
</script>
  
<style lang="scss" scoped>
.logistic-container {
  @apply p-5 flex flex-col items-center gap-5 bg-white rounded-lg shadow-md;
}
</style> 